<template>
  <ModalDialog
    ref="dialog"
    id="mydialog"
    @ok="onSave"
    @cancel="cancelModal"
    :maxWidth="360"
    :showCancelIcon="false"
    :displayCancelButton="displayCancelButton"
    :posX="posX"
    :posY="posY"
    :dlgStyle="dlgStyle"
    :displayOkButton="true"
    :labelOk="myLabelOk"
    :labelCancel="$t('general.no')"
  >
    <div ref="mydialog" class="dlg-choice">
      <div class="text-size-20 text-center border-bottom p-2">
        <slot></slot>
      </div>
    </div>
  </ModalDialog>
</template>
<script>
import { constants } from '@/shared/constant';
//import { faTachometerSlow } from '@fortawesome/pro-light-svg-icons';

export default {
  name: 'ModalConfirmDialog',

  data() {
    return {
      posX: 0,
      posY: 0,
      modalDialog: null,
    };
  },

  props: {
    labelOk: {
      type: String,
    },
    displayCancelButton: {
    default: true,
    type: Boolean
  }    
  },

  computed: {
    myLabelOk() {
      if (this.labelOk) return this.labelOk;
      return this.$t('general.yes');
    },
    dlgStyle() {
      const dlgWidth = 360;

      const dlgHeight = 360 + 100;
      const padding = 20;

      if (this.mobileView) {
        let top = this.posY;
        if (top + dlgHeight + padding > window.innerHeight)
          top = window.innerHeight - dlgHeight - padding;

        return 'margin:' + top + 'px auto';
      }

      let left = this.posX;
      if (left + dlgWidth + padding > window.innerWidth)
        left = window.innerWidth - dlgWidth - padding;

      let top = this.posY;
      if (top + dlgHeight + padding > window.innerHeight)
        top = window.innerHeight - dlgHeight - padding;

      const s = ';left:' + left + 'px; top:' + top + 'px';
      return s;
    },
    mobileView() {
      return this.$store.state.mobileView;
    },

    getDescriptionLength() {
      return (
        (this.task.description ? this.task.description.length : 0) +
        ' / ' +
        constants.textAreaMaxCharacterLimit
      );
    },
  },

  methods: {
    openModal(event) {
      this.posX = event.clientX;
      this.posY = event.clientY;
      this.$refs.dialog.openModal(event);
    },

    cancelModal() {
      this.$emit('cancel');
    },

    closeModal() {
      this.$refs.dialog.closeModal();
    },
    onSave() {
      this.$refs.dialog.closeModal();
      this.$emit('ok');
    },
  },

  updated() {
    this.modalDialog = this.$refs.dialog;
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/style.scss';

input.tasks-cont {
  width: 50px;
}
</style>
